var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"brand_grid__item",attrs:{"href":_vm.brandLink.url,"target":_vm.brandLink.target}},[_c('img',{attrs:{"src":_vm.brandLogo,"alt":_vm.brandLink.title ? _vm.brandLink.title : 'Brand'}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib?{}!./scripts/vue/BrandGridItem.vue?vue&type=template&id=38d5b4de&scoped=true&
// module id = 255
// module chunks = 0